import invert from 'lodash/invert';

import { UnitedStates } from '@headway/api/models/UnitedStates';

export const statesToDisplayNames: Record<UnitedStates, string> = {
  [UnitedStates.ALABAMA]: 'Alabama',
  [UnitedStates.ALASKA]: 'Alaska',
  [UnitedStates.ARIZONA]: 'Arizona',
  [UnitedStates.ARKANSAS]: 'Arkansas',
  [UnitedStates.CALIFORNIA]: 'California',
  [UnitedStates.COLORADO]: 'Colorado',
  [UnitedStates.CONNECTICUT]: 'Connecticut',
  [UnitedStates.DELAWARE]: 'Delaware',
  [UnitedStates.DISTRICT_OF_COLUMBIA]: 'District of Columbia',
  [UnitedStates.FLORIDA]: 'Florida',
  [UnitedStates.GEORGIA]: 'Georgia',
  [UnitedStates.HAWAII]: 'Hawaii',
  [UnitedStates.IDAHO]: 'Idaho',
  [UnitedStates.ILLINOIS]: 'Illinois',
  [UnitedStates.INDIANA]: 'Indiana',
  [UnitedStates.IOWA]: 'Iowa',
  [UnitedStates.KANSAS]: 'Kansas',
  [UnitedStates.KENTUCKY]: 'Kentucky',
  [UnitedStates.LOUISIANA]: 'Louisiana',
  [UnitedStates.MAINE]: 'Maine',
  [UnitedStates.MARYLAND]: 'Maryland',
  [UnitedStates.MASSACHUSETTS]: 'Massachusetts',
  [UnitedStates.MICHIGAN]: 'Michigan',
  [UnitedStates.MINNESOTA]: 'Minnesota',
  [UnitedStates.MISSISSIPPI]: 'Mississippi',
  [UnitedStates.MISSOURI]: 'Missouri',
  [UnitedStates.MONTANA]: 'Montana',
  [UnitedStates.NEBRASKA]: 'Nebraska',
  [UnitedStates.NEVADA]: 'Nevada',
  [UnitedStates.NEW_HAMPSHIRE]: 'New Hampshire',
  [UnitedStates.NEW_JERSEY]: 'New Jersey',
  [UnitedStates.NEW_MEXICO]: 'New Mexico',
  [UnitedStates.NEW_YORK]: 'New York',
  [UnitedStates.NORTH_CAROLINA]: 'North Carolina',
  [UnitedStates.NORTH_DAKOTA]: 'North Dakota',
  [UnitedStates.OHIO]: 'Ohio',
  [UnitedStates.OKLAHOMA]: 'Oklahoma',
  [UnitedStates.OREGON]: 'Oregon',
  [UnitedStates.PENNSYLVANIA]: 'Pennsylvania',
  [UnitedStates.RHODE_ISLAND]: 'Rhode Island',
  [UnitedStates.SOUTH_CAROLINA]: 'South Carolina',
  [UnitedStates.SOUTH_DAKOTA]: 'South Dakota',
  [UnitedStates.TENNESSEE]: 'Tennessee',
  [UnitedStates.TEXAS]: 'Texas',
  [UnitedStates.UTAH]: 'Utah',
  [UnitedStates.VERMONT]: 'Vermont',
  [UnitedStates.VIRGIN_ISLANDS]: 'U.S. Virgin Islands',
  [UnitedStates.VIRGINIA]: 'Virginia',
  [UnitedStates.WASHINGTON]: 'Washington',
  [UnitedStates.WEST_VIRGINIA]: 'West Virginia',
  [UnitedStates.WISCONSIN]: 'Wisconsin',
  [UnitedStates.WYOMING]: 'Wyoming',
  [UnitedStates.PUERTO_RICO]: 'Puerto Rico',
};

export const unitedStatesAbbreviations: Record<UnitedStates, string> = {
  [UnitedStates.ALASKA]: 'AK',
  [UnitedStates.ALABAMA]: 'AL',
  [UnitedStates.ARKANSAS]: 'AR',
  [UnitedStates.ARIZONA]: 'AZ',
  [UnitedStates.CALIFORNIA]: 'CA',
  [UnitedStates.COLORADO]: 'CO',
  [UnitedStates.CONNECTICUT]: 'CT',
  [UnitedStates.DISTRICT_OF_COLUMBIA]: 'DC',
  [UnitedStates.DELAWARE]: 'DE',
  [UnitedStates.FLORIDA]: 'FL',
  [UnitedStates.GEORGIA]: 'GA',
  [UnitedStates.HAWAII]: 'HI',
  [UnitedStates.IOWA]: 'IA',
  [UnitedStates.IDAHO]: 'ID',
  [UnitedStates.ILLINOIS]: 'IL',
  [UnitedStates.INDIANA]: 'IN',
  [UnitedStates.KANSAS]: 'KS',
  [UnitedStates.KENTUCKY]: 'KY',
  [UnitedStates.LOUISIANA]: 'LA',
  [UnitedStates.MASSACHUSETTS]: 'MA',
  [UnitedStates.MARYLAND]: 'MD',
  [UnitedStates.MAINE]: 'ME',
  [UnitedStates.MICHIGAN]: 'MI',
  [UnitedStates.MINNESOTA]: 'MN',
  [UnitedStates.MISSOURI]: 'MO',
  [UnitedStates.MISSISSIPPI]: 'MS',
  [UnitedStates.MONTANA]: 'MT',
  [UnitedStates.NORTH_CAROLINA]: 'NC',
  [UnitedStates.NORTH_DAKOTA]: 'ND',
  [UnitedStates.NEBRASKA]: 'NE',
  [UnitedStates.NEW_HAMPSHIRE]: 'NH',
  [UnitedStates.NEW_JERSEY]: 'NJ',
  [UnitedStates.NEW_MEXICO]: 'NM',
  [UnitedStates.NEVADA]: 'NV',
  [UnitedStates.NEW_YORK]: 'NY',
  [UnitedStates.OHIO]: 'OH',
  [UnitedStates.OKLAHOMA]: 'OK',
  [UnitedStates.OREGON]: 'OR',
  [UnitedStates.PENNSYLVANIA]: 'PA',
  [UnitedStates.RHODE_ISLAND]: 'RI',
  [UnitedStates.SOUTH_CAROLINA]: 'SC',
  [UnitedStates.SOUTH_DAKOTA]: 'SD',
  [UnitedStates.TENNESSEE]: 'TN',
  [UnitedStates.TEXAS]: 'TX',
  [UnitedStates.UTAH]: 'UT',
  [UnitedStates.VIRGIN_ISLANDS]: 'VI',
  [UnitedStates.VIRGINIA]: 'VA',
  [UnitedStates.VERMONT]: 'VT',
  [UnitedStates.WASHINGTON]: 'WA',
  [UnitedStates.WISCONSIN]: 'WI',
  [UnitedStates.WEST_VIRGINIA]: 'WV',
  [UnitedStates.WYOMING]: 'WY',
  [UnitedStates.PUERTO_RICO]: 'PR',
} as const;

export const unitedStatesSlugs: Record<UnitedStates, string> = {
  [UnitedStates.ALABAMA]: 'alabama',
  [UnitedStates.ALASKA]: 'alaska',
  [UnitedStates.ARIZONA]: 'arizona',
  [UnitedStates.ARKANSAS]: 'arkansas',
  [UnitedStates.CALIFORNIA]: 'california',
  [UnitedStates.COLORADO]: 'colorado',
  [UnitedStates.CONNECTICUT]: 'connecticut',
  [UnitedStates.DELAWARE]: 'delaware',
  [UnitedStates.DISTRICT_OF_COLUMBIA]: 'dc',
  [UnitedStates.FLORIDA]: 'florida',
  [UnitedStates.GEORGIA]: 'georgia',
  [UnitedStates.HAWAII]: 'hawaii',
  [UnitedStates.IDAHO]: 'idaho',
  [UnitedStates.ILLINOIS]: 'illinois',
  [UnitedStates.INDIANA]: 'indiana',
  [UnitedStates.IOWA]: 'iowa',
  [UnitedStates.KANSAS]: 'kansas',
  [UnitedStates.KENTUCKY]: 'kentucky',
  [UnitedStates.LOUISIANA]: 'louisiana',
  [UnitedStates.MAINE]: 'maine',
  [UnitedStates.MARYLAND]: 'maryland',
  [UnitedStates.MASSACHUSETTS]: 'massachusetts',
  [UnitedStates.MICHIGAN]: 'michigan',
  [UnitedStates.MINNESOTA]: 'minnesota',
  [UnitedStates.MISSISSIPPI]: 'mississippi',
  [UnitedStates.MISSOURI]: 'missouri',
  [UnitedStates.MONTANA]: 'montana',
  [UnitedStates.NEBRASKA]: 'nebraska',
  [UnitedStates.NEVADA]: 'nevada',
  [UnitedStates.NEW_HAMPSHIRE]: 'new-hampshire',
  [UnitedStates.NEW_JERSEY]: 'new-jersey',
  [UnitedStates.NEW_MEXICO]: 'new-mexico',
  [UnitedStates.NEW_YORK]: 'new-york',
  [UnitedStates.NORTH_CAROLINA]: 'north-carolina',
  [UnitedStates.NORTH_DAKOTA]: 'north-dakota',
  [UnitedStates.OHIO]: 'ohio',
  [UnitedStates.OKLAHOMA]: 'oklahoma',
  [UnitedStates.OREGON]: 'oregon',
  [UnitedStates.PENNSYLVANIA]: 'pennsylvania',
  [UnitedStates.RHODE_ISLAND]: 'rhode-island',
  [UnitedStates.SOUTH_CAROLINA]: 'south-carolina',
  [UnitedStates.SOUTH_DAKOTA]: 'south-dakota',
  [UnitedStates.TENNESSEE]: 'tennessee',
  [UnitedStates.TEXAS]: 'texas',
  [UnitedStates.UTAH]: 'utah',
  [UnitedStates.VERMONT]: 'vermont',
  [UnitedStates.VIRGIN_ISLANDS]: 'u.s.-virgin-islands',
  [UnitedStates.VIRGINIA]: 'virginia',
  [UnitedStates.WASHINGTON]: 'washington',
  [UnitedStates.WEST_VIRGINIA]: 'west-virginia',
  [UnitedStates.WISCONSIN]: 'wisconsin',
  [UnitedStates.WYOMING]: 'wyoming',
  [UnitedStates.PUERTO_RICO]: 'puerto-rico',
} as const;

export const displayNameToUsStateEnum = invert(statesToDisplayNames);
export const abbreviationToStateEnum = invert(unitedStatesAbbreviations);
export const slugToStateEnum = invert(unitedStatesSlugs);
export default statesToDisplayNames;
